
import { Link } from 'react-router-dom';

export default function StockistHighlight() {
  return (
    <section className="py-14 md:py-24 px-4 md:px-8 bg-[#1A1A1A] text-white overflow-x-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full text-center md:text-left">
            <h2 className="text-2xl md:text-4xl font-bold mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Find Your Nearest Stockist
            </h2>
            <p className="text-base md:text-lg text-gray-300 mb-6">
              With over 200 locations across the UK, there's a Best Building Supplies stockist near you. Get same-day collection or next-day delivery on all products.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <button className="w-full sm:w-auto min-h-[48px] bg-[#F2C612] text-[#1A1A1A] px-8 py-3 rounded-lg font-semibold hover:bg-[#d4ad0a] transition-colors whitespace-nowrap cursor-pointer">
                Find a Stockist
              </button>
              <button className="w-full sm:w-auto min-h-[48px] border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-[#1A1A1A] transition-colors whitespace-nowrap cursor-pointer">
                Become a Stockist
              </button>
            </div>
          </div>
          <div className="flex-1 w-full h-[250px] md:h-80 rounded-lg overflow-hidden">
            <img 
              src="https://static.readdy.ai/image/783dd8c3d2d1f38f9648f46144ac17f1/9fa29f9dffb9042101fb40481b4c19e1.png"
              alt="Best Building Supplies stockist location"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
